import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import IAgendamento from '../../Interfaces/agendamento/agendamento.interface';
import IVL_Agendamento from '../../Interfaces/agendamento/VL_agendamento.interface';
import api from '../../Services/ApiService';
// import CreateReadUpdateModal from '../CreateReadUpdateModal';
import { columns } from './columns';
import { FlexBoxSpaceBetween } from './styles';

// import { Container } from './styles';

const TabelaAgendamentosPendentes: React.FC = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [updatedData,setUpdatedData] = useState<boolean>(false);
  const [agendamentos,setAgendamentos] = useState<IVL_Agendamento[]>([]);

  useEffect(()=>{
    GetAgendamentos();
    setUpdatedData(false);
  },[updatedData])
  
  const GetAgendamentos = async () => {
    const {data} = await api.get<IVL_Agendamento[]>('/vl_agendamentos/pendentes');
    setAgendamentos(data);
  }

  const aprovarAgendamento = async (id:number) => {
    try {
      Swal.fire({
        title: 'Deseja realmente aprovar este agendamento?',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Aprovar',
        confirmButtonColor: '#1B5E20',
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          await api.post<IAgendamento>(`/agendamentos/aprovaragendamento/${id}`);
          setUpdatedData(true);
        },
        allowOutsideClick: () => !Swal.isLoading()
      });
      
    } catch (error) {
      return Swal.fire({
        title:'Erro!',
        text:`${error}`,
        icon: 'error'
      })
    }
  }
  
  const recusarAgendamento = async (id:number) => {
    try {
      Swal.fire({
        title: 'Deseja realmente recusar este agendamento?',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Recusar',
        confirmButtonColor: '#C62828',
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          await api.post<IAgendamento>(`/agendamentos/recusaragendamento/${id}`);
          setUpdatedData(true);
        },
        allowOutsideClick: () => !Swal.isLoading()
      });
    } catch (error) {
      return Swal.fire({
        title:'Erro!',
        text:`${error}`,
        icon: 'error'
      })
    }
  }

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell align="center" colSpan={7}>
                <h2>
                  Agendamentos Pendentes de Aprovação
                </h2>
              </TableCell>
            </TableRow>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, maxWidth: column.maxWidth }}
                >
                <h3>
                  {column.label}
                </h3>  
                </TableCell>
              ))}
              <TableCell align='center'>
                <h3 style={{minWidth:70}}>
                  Ações
                </h3> 
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {agendamentos
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((agendamento,index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    {columns.map((column) => {
                      const value = agendamento[column.id];
                      return (
                        <TableCell sx={{fontSize:'10pt'}} key={column.id} align={column.align}>
                          {column.format
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                    <TableCell align='right'>
                      <FlexBoxSpaceBetween>
                        <Button 
                          variant="contained" 
                          color="success" 
                          size="small"
                          onClick={() => aprovarAgendamento(agendamento.id)}>
                          Aprovar
                        </Button>
                        <Button 
                          variant="contained" 
                          color="error" 
                          size="small"
                          onClick={()=> recusarAgendamento(agendamento.id)}>
                          Recusar
                        </Button>
                      </FlexBoxSpaceBetween>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 100]}
        component="div"
        count={agendamentos.length}
        rowsPerPage={rowsPerPage}
        page={page}
        showFirstButton
        showLastButton
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
    </>
  );
}

export default TabelaAgendamentosPendentes;